import { combineReducers } from "redux";

import subscription_validity from "../features/admin/subscription/subscription_validity/Slice";
import subscription_features from "../features/admin/subscription/subscription_features/Slice";
import subscription from "../features/admin/subscription/subscription/Slice";

const Subscription = combineReducers({
  subscription_validity,
  subscription_features,
  subscription,
});

export default Subscription;
